module.exports = __webpack_public_path__ + "img/hero.73863e12.jpg";